// extracted by mini-css-extract-plugin
export default {"button":"button_button__ktA4d","icon":"button_icon__0X9An","secondary":"button_secondary__nee2q","tertiary":"button_tertiary__dj8CF","disabled":"button_disabled__Xp+DF"};